import {
  EDIT_CURENCY_SPREAD_FAILURE,
  EDIT_CURENCY_SPREAD_STARTED,
  EDIT_CURENCY_SPREAD_SUCCESS,
  GET_CURENCY_SPREAD_TYPES_FAILURE,
  GET_CURENCY_SPREAD_TYPES_STARTED,
  GET_CURENCY_SPREAD_TYPES_SUCCESS,
  GET_TOP_UP_BANKS_FAILURE,
  GET_TOP_UP_BANKS_STARTED,
  GET_TOP_UP_BANKS_SUCCESS,
  GET_TOP_UP_COUNTRIES_FAILURE,
  GET_TOP_UP_COUNTRIES_STARTED,
  GET_TOP_UP_COUNTRIES_SUCCESS,
  GET_TOP_UP_IBAN_LIST_FAILURE,
  GET_TOP_UP_IBAN_LIST_STARTED,
  GET_TOP_UP_IBAN_LIST_SUCCESS,
  GET_TOP_UP_LIST_FAILURE,
  GET_TOP_UP_LIST_STARTED,
  GET_TOP_UP_LIST_SUCCESS,
  LOGIN_DEFAULT,
} from "redux/ActionTypes";
// --------------------------------------------------------------------------------
const initialState = {
  rType: LOGIN_DEFAULT,
  topUpList: { records: [], count: 0 },
  topUpCountries: [],
  topUpBanks: [],
  ibanList: [],
  currencySpreadTypes: [],
  error: "",
};
export const TopUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOP_UP_LIST_STARTED:
    case GET_TOP_UP_COUNTRIES_STARTED:
    case GET_TOP_UP_BANKS_STARTED:
    case GET_TOP_UP_IBAN_LIST_STARTED:
    case EDIT_CURENCY_SPREAD_STARTED:
    case GET_CURENCY_SPREAD_TYPES_STARTED:
      return {
        ...state,
        rType: action.type,
        error: "",
      };
    case GET_TOP_UP_LIST_SUCCESS:
      return {
        ...state,
        rType: GET_TOP_UP_LIST_SUCCESS,
        topUpList: action.payload.topUpList,
        error: "",
      };
    case GET_TOP_UP_COUNTRIES_SUCCESS:
      return {
        ...state,
        rType: GET_TOP_UP_COUNTRIES_SUCCESS,
        topUpCountries: action.payload.topUpCountries,
        error: "",
      };
    case GET_TOP_UP_BANKS_SUCCESS:
      return {
        ...state,
        rType: GET_TOP_UP_COUNTRIES_SUCCESS,
        topUpBanks: action.payload.topUpBanks,
        error: "",
      };
    case GET_TOP_UP_IBAN_LIST_SUCCESS:
      return {
        ...state,
        rType: GET_TOP_UP_IBAN_LIST_SUCCESS,
        ibanList: action.payload.ibanList,
        error: "",
      };
    case EDIT_CURENCY_SPREAD_SUCCESS:
      return {
        ...state,
        rType: EDIT_CURENCY_SPREAD_SUCCESS,
        error: "",
      };
    case GET_CURENCY_SPREAD_TYPES_SUCCESS:
      return {
        ...state,
        rType: GET_CURENCY_SPREAD_TYPES_SUCCESS,
        currencySpreadTypes: action.payload.currencySpreadTypes,
        error: "",
      };
    case GET_TOP_UP_LIST_FAILURE:
    case GET_TOP_UP_COUNTRIES_FAILURE:
    case GET_TOP_UP_BANKS_FAILURE:
    case GET_TOP_UP_IBAN_LIST_FAILURE:
    case EDIT_CURENCY_SPREAD_FAILURE:
    case GET_CURENCY_SPREAD_TYPES_FAILURE:
      return {
        ...state,
        rType: action.type,
        error: action.payload,
      };
    default:
      return state;
  }
};
